module.exports = __webpack_public_path__ + "static/img/wgs.cb7325a.png";


//////////////////
// WEBPACK FOOTER
// ./static/xd/wgs.png
// module id = YMZG
// module chunks = 0